import TimeDistributionChart from './TimeDistributionChart';
import ProjectsBySkillSection from './ProjectsBySkilllSection';
import GoalsSection from './GoalsSection';
import type { ChartDataItem } from './TimeDistributionChart';
import type { Project } from './ProjectsBySkilllSection';
import type { Goal } from './GoalsSection';

interface Pagination {
    total_pages: number;
    current_page: number;
    total_items: number;
    has_next: boolean;
    has_previous: boolean;
}

interface RightContentProps {
    viewMode: 'skills' | 'climb';
    chartData: ChartDataItem[];
    colors: string[];
    projects: Project[];
    projectsLoading: boolean;
    projectsError: any;
    projectsPagination: Pagination | null;
    projectsPage: number;
    onProjectsPageChange: (page: number) => void;
    goals: Goal[];
    goalsLoading: boolean;
    goalsError: any;
    goalsPagination: Pagination | null;
    goalsPage: number;
    onGoalsPageChange: (page: number) => void;
    selectedSkill: string | null;
    onSkillSelect: (skill: string | null) => void;
    selectedClimbType: string | null;
    onClimbTypeSelect: (climbType: string | null) => void;
    timeDistributionLoading: boolean;
    timeDistributionError: any;
}

const RightContent = ({ 
    viewMode,
    chartData, 
    colors, 
    projects, 
    projectsLoading, 
    projectsError, 
    projectsPagination, 
    projectsPage, 
    onProjectsPageChange, 
    goals, 
    goalsLoading, 
    goalsError, 
    goalsPagination, 
    goalsPage, 
    onGoalsPageChange, 
    selectedSkill, 
    onSkillSelect,
    selectedClimbType,
    onClimbTypeSelect,
    timeDistributionLoading, 
    timeDistributionError 
}: RightContentProps) => {
    const selectedItem = viewMode === 'skills' ? selectedSkill : selectedClimbType;
    const handleSelect = viewMode === 'skills' ? onSkillSelect : onClimbTypeSelect;
    const labelType = viewMode === 'skills' ? 'Skill' : 'CLIMB Type';

    return (
        <div className="flex-1 flex flex-col gap-6 userprofile-right-content">
            <TimeDistributionChart
                chartData={chartData}
                colors={colors}
                selectedSkill={selectedItem}
                onSkillSelect={handleSelect}
                loading={timeDistributionLoading}
                error={timeDistributionError}
            />
            {selectedItem && (
                <div className="flex flex-row gap-6 mq991:flex-col">
                    <div className="flex-1">
                        <ProjectsBySkillSection 
                            projects={projects} 
                            selectedSkill={selectedItem}
                            loading={projectsLoading}
                            error={projectsError}
                            pagination={projectsPagination}
                            currentPage={projectsPage}
                            onPageChange={onProjectsPageChange}
                            labelType={labelType}
                        />
                    </div>
                    <div className="flex-1">
                        <GoalsSection 
                            goals={goals} 
                            selectedSkill={selectedItem}
                            loading={goalsLoading}
                            error={goalsError}
                            pagination={goalsPagination}
                            currentPage={goalsPage}
                            onPageChange={onGoalsPageChange}
                            labelType={labelType}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default RightContent;
